import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Exact hostname resolution applies a tenant theme or leaves the generic
// document unthemed when the host is unknown.
import { applyTenantTheme } from "@/stores/theme-store";
import { installAssignmentDraftPopInterceptor } from "@/components/assignments/assignment-draft-pop-interceptor";
applyTenantTheme();
installAssignmentDraftPopInterceptor();

import "./index.css";
import App from "./App.tsx";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
